<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <v-card class="rounded-lg">
      <v-card-title class="pa-4 border-bottom">
        <span class="text-h6 font-weight-bold grey--text text--darken-2">
          <v-icon class="mr-2">{{ icons.mdiAccountPlus }}</v-icon>
          Novo Cliente Rápido
        </span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="form.name"
            label="Nome Completo"
            outlined
            dense
            :rules="[v => !!v || 'Nome é obrigatório']"
            :prepend-inner-icon="icons.mdiAccount"
          ></v-text-field>

          <v-text-field
            v-model="form.cpf"
            label="CPF"
            outlined
            dense
            v-mask="'###.###.###-##'"
            :rules="[v => !!v || 'CPF é obrigatório', rules.cpf]"
            :prepend-inner-icon="icons.mdiCardAccountDetails"
          ></v-text-field>

          <div class="d-flex">
             <v-text-field
              v-model="form.cep"
              label="CEP"
              outlined
              dense
              v-mask="'#####-###'"
              :rules="[v => !!v || 'CEP é obrigatório']"
              :prepend-inner-icon="icons.mdiMapMarker"
              class="mr-2"
              @blur="fetchAddress"
              :loading="addressLoading"
            ></v-text-field>
          </div>
          
          <!-- Hidden/Auto-filled fields for better data structure -->
           <v-expand-transition>
             <div v-if="addressDetails" class="caption grey--text mb-4 px-1">
               {{ addressDetails }}
             </div>
           </v-expand-transition>

        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4 pt-0">
        <v-btn text color="grey darken-1" @click="close">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          color="success" 
          class="px-6" 
          :loading="loading" 
          @click="submit"
        >
          <v-icon left>{{ icons.mdiCheck }}</v-icon>
          Cadastrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiAccountPlus, mdiClose, mdiAccount, mdiCardAccountDetails, mdiMapMarker, mdiCheck } from '@mdi/js';

export default {
  name: "POSCustomerModal",
  data() {
    return {
      dialog: false,
      valid: true,
      loading: false,
      addressLoading: false,
      addressDetails: "",
      form: {
        name: "",
        cpf: "",
        cep: "",
        // Hidden/Default
        is_pf: 1,
        is_pj: 0,
        main_address: {
            type: "mainAddress",
            cep: "",
            street: "",
            neighborhood: "",
            city: "",
            state: ""
        }
      },
      icons: {
        mdiAccountPlus, mdiClose, mdiAccount, mdiCardAccountDetails, mdiMapMarker, mdiCheck
      },
      rules: {
         cpf: (v) => /^\d{3}.?\d{3}.?\d{3}-?\d{2}$/.test(v) || "CPF inválido",
      }
    };
  },
  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    reset() {
      if(this.$refs.form) this.$refs.form.reset();
      this.form = {
        name: "",
        cpf: "",
        cep: "",
        is_pf: 1,
        is_pj: 0,
        main_address: { type: "mainAddress" }
      };
      this.addressDetails = "";
    },
    fetchAddress() {
       if(!this.form.cep || this.form.cep.length < 8) return;
       
       this.addressLoading = true;
       // Assuming standard viaCEP or similar, or just relying on user input. 
       // Since the user didn't ask for auto-complete of address, I will just validate CEP format.
       // However, to fill the backend structure correctly, I might need to send a valid address object.
       // I'll try to fetch via a public API or internal helper if available, otherwise just save CEP.
       
       fetch(`https://viacep.com.br/ws/${this.form.cep.replace(/\D/g, '')}/json/`)
         .then(res => res.json())
         .then(data => {
            if(!data.erro) {
                this.form.main_address = {
                    type: "mainAddress",
                    cep: data.cep,
                    street: data.logradouro,
                    neighborhood: data.bairro,
                    city: data.localidade,
                    state: data.uf,
                    number: "S/N" // Default
                };
                this.addressDetails = `${data.logradouro}, ${data.bairro} - ${data.localidade}/${data.uf}`;
            }
         })
         .finally(() => {
             this.addressLoading = false;
         });
    },
    submit() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      
      const payload = {
          ...this.form,
          // Ensure structure matches what CustomerForm sends
          main_address: {
              ...this.form.main_address,
              cep: this.form.cep
          }
      };

      this.$http.store("/customer", payload)
        .then((res) => {
          this.$toast.success("Cliente cadastrado!");
          this.$emit('created', res.data.data || res.data); // Adjust based on API response
          this.close();
        })
        .catch(err => {
            console.error(err);
            this.$toast.error("Erro ao cadastrar cliente.");
        })
        .finally(() => {
            this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.border-bottom { border-bottom: 1px solid #eee; }
</style>
